import { resolveMediaUrl } from '../../lib/mediaUrl';

export default function BackgroundRenderer({ background }) {
  if (!background) return <div style={{ position: 'absolute', inset: 0, background: '#0f0f0f' }} />;
  const { type } = background;

  let bgStyle = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
  };

  if (type === 'color') {
    bgStyle.background = background.color || '#000000';
  } else if (type === 'gradient' && background.gradient) {
    const { gradient } = background;
    const stops = (gradient.stops || []).map((s) => `${s.color} ${s.position}%`).join(', ');
    if (gradient.type === 'linear') {
      bgStyle.background = `linear-gradient(${gradient.direction}deg, ${stops})`;
    } else {
      bgStyle.background = `radial-gradient(circle, ${stops})`;
    }
  } else if (type === 'image' && background.mediaSrc) {
    const focal = background.focalPoint;
    const pos = focal ? `${focal.x * 100}% ${focal.y * 100}%` : 'center';
    bgStyle = {
      ...bgStyle,
      backgroundImage: `url(${resolveMediaUrl(background.mediaSrc)})`,
      backgroundSize: 'cover',
      backgroundPosition: pos,
    };
  } else if (type === 'video' && background.mediaSrc) {
    return (
      <>
        <div style={{ ...bgStyle, background: '#000' }} />
        <video
          src={resolveMediaUrl(background.mediaSrc)}
          style={{ ...bgStyle, objectFit: 'cover' }}
          autoPlay
          loop
          muted
          playsInline
          poster={background.posterSrc ? resolveMediaUrl(background.posterSrc) : undefined}
        />
        {background.overlay && background.overlay.opacity > 0 && (
          <div
            style={{
              ...bgStyle,
              background: background.overlay.color,
              opacity: background.overlay.opacity,
            }}
          />
        )}
      </>
    );
  } else {
    // Fallback: use the page's color field if set (e.g. when Unsplash image is missing)
    bgStyle.background = background.color || '#0f0f0f';
  }

  return (
    <>
      <div style={bgStyle} />
      {background.overlay && background.overlay.opacity > 0 && (
        <div
          style={{
            position: 'absolute', inset: 0,
            background: background.overlay.color,
            opacity: background.overlay.opacity,
          }}
        />
      )}
    </>
  );
}
